"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionError = void 0;
class TransactionError extends Error {
    constructor(message, txid, code, programIds, serializedTx) {
        super(message);
        this.name = 'TransactionError';
        this.txid = txid;
        this.code = code;
        this.programIds = programIds;
        this.serializedTx = serializedTx;
    }
}
exports.TransactionError = TransactionError;
